import { Dialog, DialogContent, Grid } from '@material-ui/core';
import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Texto from '@infotrack/presentacion-componentes/texto';
import { manejadorDialogoGlobal } from '@infotrack/presentacion-utilitarios/manejadoresComponentes';

import IDocumentoConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoConsultaGeneral';
import IDocumentoDetalleConsultaGeneral from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/IDocumentoDetalleConsultaGeneral';
import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import TiposProceso from 'Infotrack@Modelos/negocioRefactor/enumeraciones/TiposProceso';
import IBodegaDivisiones from 'Infotrack@Modelos/smartStock/bodegasDivisiones/entidades/bodegasDivisiones';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import IItemsConsulta from 'Infotrack@Modelos/smartStock/items/entidades/IItemsConsulta';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import DetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormulario/DetallesFormulario';
import EstadosDetallesFormulario from 'Infotrack@Transversales/componentes/DetallesFormulario/enumeraciones';
import DetallesInventario from 'Infotrack@Transversales/componentes/DetallesInventario/DetallesInventario';
import DocumentoValorTotal from 'Infotrack@Transversales/componentes/DocumentoValorTotal/DocumentoValorTotal';
import { EstadosFormularioDocumento } from 'Infotrack@Transversales/componentes/FormularioDocumento/enumeraciones';
import FormularioDocumento, {
    IEntidadesFormularioDocumento,
} from 'Infotrack@Transversales/componentes/FormularioDocumento/FormularioDocumento';
import ModalEncabezado from 'Infotrack@Transversales/componentes/ModalEncabezado/ModalEncabezado';
import TablaDetalles from 'Infotrack@Transversales/componentes/TablaDetalles/TablaDetalles';

import {
    CAMPOS_DESHABILITAR_DETALLES_FORMULARIO,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO,
    CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION,
    CAMPOS_OCULTAR_DETALLES_FORMULARIO,
    CAMPOS_OCULTAR_DETALLES_TABLA,
    CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO,
    ENTIDADES_DOCUMENTO_POR_DEFECTO,
    CAMPOS_EDITABLES_DETALLES_INVENTARIO,
    CAMPOS_OCULTAR_DETALLES_INVENTARIO,
} from './constantes';
import EntidadesDetalleCM from './controladorModelo/EntidadesDetalleCM';
import EntidadesDocumentoCM from './controladorModelo/EntidadesDocumentoCM';
import ItemCM from './controladorModelo/ItemCM';
import MovimientoCM from './controladorModelo/MovimientoCM';
import OrdenSalidaCM from './controladorModelo/OrdenSalidaCM';
import { EstadosModalOrdenSalida } from './enumeraciones';
import { estadoActivo } from 'Infotrack@Transversales/constantes/ConstantesEstados';

interface IModalOrdenSalidaProps {
    cerrar: () => void;
    documentoId: string | null;
    establecerDocumentoId: (documentoId: string) => void;
    estado: EstadosModalOrdenSalida;
    descargarDocumentoPdf: (documento: IDocumentoConsultaGeneral) => any;
}

const ModalOrdenSalida: FunctionComponent<IModalOrdenSalidaProps> = ({
    cerrar,
    documentoId,
    establecerDocumentoId,
    estado,
    descargarDocumentoPdf,
}) => {
    const idPerfilResponsable = process.env.REACT_APP_ID_PERFIL_RESPONSABLE!;
    const entidadesDocumentoCM = useMemo(() => new EntidadesDocumentoCM(), []);
    const ordenSalidaCM = useMemo(() => new OrdenSalidaCM(), []);
    const itemCM = useMemo(() => new ItemCM(), []);
    const movimientoCM = useMemo(() => new MovimientoCM(), []);
    const entidadesDetalleCM = useMemo(() => new EntidadesDetalleCM(), []);
    const [ejecutarConsultarDocumentos, setEjecutarConsultarDocumentos] = useState<boolean>(false);

    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    const idAgencia = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.agenciaActual!.IdAgencia);
    const idUsuario = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdUsuario);

    const [entidadesDocumento, setEntidadesDocumento] = useState<Partial<IEntidadesFormularioDocumento>>(
        ENTIDADES_DOCUMENTO_POR_DEFECTO
    );
    const [documento, setDocumento] = useState<IDocumentoConsultaGeneral | null>(null);
    const [etapasSiguientes, setEtapasSiguientes] = useState<IEtapas[]>([]);
    const [items, setItems] = useState<IItemsConsulta[]>([]);
    const [entidadesDetalle, setEntidadesDetalle] = useState<{
        items: IItemsConsulta[];
        divisionesOrigen: IBodegaDivisiones[];
    }>({ items: [], divisionesOrigen: [] });
    const [detalles, setDetalles] = useState<IDocumentoDetalleConsultaGeneral[]>([]);
    const [detalleInicialEdicion, setDetalleInicialEdicion] = useState<IDocumentoDetalle | null>(null);

    useEffect(() => {
        alCambiarEstado();
    }, [estado]);

    useEffect(() => {
        if (documento) alEstablecerDocumento();
    }, [documento]);
    useEffect(() => {
        consultarDetalles();
    }, [ejecutarConsultarDocumentos]);

    const alCambiarEstado = async () => {
        if (estado === EstadosModalOrdenSalida.CERRADO) {
            setDocumento(null);
            setDetalles([]);
            setEntidadesDocumento(ENTIDADES_DOCUMENTO_POR_DEFECTO);
            setEtapasSiguientes([]);
            setEntidadesDetalle({ items: [], divisionesOrigen: [] });
            setDetalleInicialEdicion(null);
            return;
        }
        if (estado === EstadosModalOrdenSalida.CREACION) {
            await consultarEntidadesDocumento();
        }
        if (estado === EstadosModalOrdenSalida.EDICION || estado === EstadosModalOrdenSalida.VISUALIZACION) {
            await consultarDocumento(documentoId!);
        }
    };

    const consultarEntidadesDocumento = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumento(
            idEmpresa,
            idAgencia,
            idUsuario,
            estadoActivo,
            idPerfilResponsable
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarEntidadesDocumentoEdicion = async () => {
        const entidadesDocumentoConsultadas = await entidadesDocumentoCM.consultarEntidadesDocumentoEdicion(
            idPerfilResponsable,
            documento!.BodegaOrigen!,
            idEmpresa,
            idAgencia,
            idUsuario,
            TiposProceso.ORDEN_DE_SALIDA,
            estadoActivo
        );
        setEntidadesDocumento(entidadesDocumentoConsultadas);
    };

    const consultarDocumento = async (documentoIdConsultar: string) => {
        const documentoConsultado = await ordenSalidaCM.consultarEncabezadoDocumento({
            DocumentoId: documentoIdConsultar,
        });
        setDocumento(documentoConsultado);
    };

    const alEstablecerDocumento = async () => {
        if (estado === EstadosModalOrdenSalida.CREACION) {
            establecerDocumentoId(documento!.DocumentoId);
            await consultarEtapasSiguientes();
            await consultarItems();
            await consultarEntidadesDetalle();
        }
        if (estado === EstadosModalOrdenSalida.EDICION) {
            await consultarEtapasSiguientes();
            await consultarItems();
            await consultarEntidadesDetalle();
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
        if (estado === EstadosModalOrdenSalida.VISUALIZACION) {
            await consultarDetalles();
            await consultarEntidadesDocumentoEdicion();
        }
    };

    const consultarItems = async () => {
        const itemsConsultados = await itemCM.consultarListaItemsBodega(documento!.BodegaOrigen!);
        setItems(itemsConsultados);
    };

    const consultarEntidadesDetalle = async () => {
        const entidadesDetalleConsultadas = await entidadesDetalleCM.consultarEntidadesDetalle(
            documento!.BodegaOrigen!,
            documento!.TipoDocumentoId,
            idEmpresa
        );
        setEntidadesDetalle(entidadesDetalleConsultadas);
    };

    const consultarDetalles = async () => {
        const detallesConsultados = await ordenSalidaCM.consultarDetallesDocumento({ DocumentoId: documentoId! });
        setDetalles(detallesConsultados);
    };

    const consultarEtapasSiguientes = async () => {
        const etapasSiguientesConsultadas = await ordenSalidaCM.consultarEtapas(documento!.DocumentoId);
        setEtapasSiguientes(etapasSiguientesConsultadas);
    };

    const crearDocumento = async (documentoCrear: IDocumento) => {
        const respuesta = await ordenSalidaCM.guardarEncabezado(mapearDocumentoCrear(documentoCrear));
        if (respuesta.Resultado) await consultarDocumento(respuesta.Entidades[0].DocumentoId);
    };

    const mapearDocumentoCrear = (documentoCrear: IDocumento): IDocumento => {
        return {
            ...documentoCrear,
            EmpresaId: idEmpresa,
            AgenciaId: idAgencia,
        };
    };

    const editarDocumento = async (documentoEditar: IDocumento) => {
        const respuesta = await ordenSalidaCM.editarEncabezado(documentoEditar);
        if (respuesta.Resultado) await consultarDocumento(documento!.DocumentoId);
    };

    const cambiarEtapa = async (etapaId: number) => {
        manejadorDialogoGlobal({ estado: false });
        const cambioEtapaExitoso = await ordenSalidaCM.cambiarEtapa({ ...documento!, EtapaId: etapaId });
        if (cambioEtapaExitoso) {
            await consultarDocumento(documento!.DocumentoId);
        }
    };

    const confirmarCambiarEtapa = async (etapaId: number) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => cambiarEtapa(etapaId),
            estado: true,
            mensaje: <Texto id={'etapas.CambioEtapa'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const agregarDetalles = async (detallesAgregar: IDocumentoDetalle[]) => {
        const respueta = await ordenSalidaCM.guardarDetalle(
            detallesAgregar.map((detalle) => ({
                ...detalle,
                DocumentoDetalleId: '',
                DocumentoDetallePredecesorId: detalle.DocumentoDetalleId,
                DocumentoId: documento!.DocumentoId,
                CantidadEntregada: 0,
                PesoFraccionRecibido: 0,
            }))
        );
        await consultarDetalles();
        return respueta;
    };

    const editarDetalle = async (detalle: IDocumentoDetalle) => {
        detalle.DivisionOrigen ? detalle.DivisionOrigen : 0;
        return ordenSalidaCM.editarDetalle(detalle);
    };

    const eliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({ estado: false });
        const respuesta = await ordenSalidaCM.eliminarDetalle(detalle);
        if (respuesta) {
            setDetalleInicialEdicion(null);
            consultarDetalles();
        }
    };

    const confirmarEliminarDetalle = async (detalle: IDocumentoDetalle) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarDetalle(detalle),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const consultarTipoDocumento = async (idBodega: number, nombreNodega?: string) => {
        if (nombreNodega === 'BodegaOrigen') {
            const tiposDocumentosBodega = await entidadesDocumentoCM.consultarTipoDocumento(idBodega, estadoActivo);
            setEntidadesDocumento({ ...entidadesDocumento, tiposDocumento: tiposDocumentosBodega });
        }
    };

    return (
        <Dialog open={estado !== EstadosModalOrdenSalida.CERRADO} maxWidth="lg">
            <ModalEncabezado
                cerrar={cerrar}
                titulo={
                    estado === EstadosModalOrdenSalida.CREACION ? (
                        <Texto id="ModalOrdenSalida.TituloCreacion" />
                    ) : estado === EstadosModalOrdenSalida.EDICION ? (
                        <Texto id="ModalOrdenSalida.TituloEdicion" />
                    ) : estado === EstadosModalOrdenSalida.VISUALIZACION ? (
                        <Texto id="ModalOrdenSalida.TituloVisualizacion" />
                    ) : (
                        undefined
                    )
                }
            />
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormularioDocumento
                            cambiarEtapa={confirmarCambiarEtapa}
                            camposDeshabilitar={
                                (estado === EstadosModalOrdenSalida.CREACION && documento) ||
                                estado === EstadosModalOrdenSalida.EDICION
                                    ? CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO_EDICION
                                    : CAMPOS_DESHABILITAR_DOCUMENTO_FORMULARIO
                            }
                            camposOcultar={CAMPOS_OCULTAR_DOCUMENTO_FORMULARIO}
                            editarDocumento={editarDocumento}
                            estado={
                                !documento
                                    ? EstadosFormularioDocumento.CREACION
                                    : (estado === EstadosModalOrdenSalida.CREACION && documento) ||
                                      estado === EstadosModalOrdenSalida.EDICION
                                    ? EstadosFormularioDocumento.EDICION
                                    : EstadosFormularioDocumento.VISUALIZACION
                            }
                            etapasSiguientes={etapasSiguientes}
                            documento={documento}
                            entidadesDocumento={entidadesDocumento}
                            guardarDocumento={crearDocumento}
                            descargarDocumentoPdf={descargarDocumentoPdf}
                            consultarTipoDocumento={consultarTipoDocumento}
                            mostrarModalEvidencia={false}
                            esTraslado={false}
                        />
                    </Grid>
                    {estado !== EstadosModalOrdenSalida.VISUALIZACION && (
                        <Grid item xs={12}>
                            <DetallesInventario
                                agregarDetalles={agregarDetalles}
                                alAgregarDetalles={consultarDetalles}
                                consultarInventario={async (bodegaId: number, itemId: number) =>
                                    movimientoCM.stockItemResponsable(bodegaId, itemId, documento!.ResponsableId!)
                                }
                                deshabilitado={!documento || !documento.ListaAcciones.PermiteAgregarDetalle}
                                documento={documento}
                                items={items}
                                tipoCantidad={'CantidadSolicitada'}
                                entidades={entidadesDetalle}
                                camposEditables={CAMPOS_EDITABLES_DETALLES_INVENTARIO}
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_INVENTARIO}
                                recibeSerial={false}
                                seriadoConsulta={true}
                                esOrdenTraslado={false}
                                mostrarPesoCampoPeso={true}
                            />
                        </Grid>
                    )}
                    {estado !== EstadosModalOrdenSalida.VISUALIZACION && (
                        <Grid item xs={12}>
                            <DetallesFormulario
                                alEditarDetalle={async () => {
                                    setDetalleInicialEdicion(null);
                                    await consultarDetalles();
                                }}
                                camposDeshabilitar={CAMPOS_DESHABILITAR_DETALLES_FORMULARIO}
                                camposOcultar={CAMPOS_OCULTAR_DETALLES_FORMULARIO}
                                detalleInicialEdicion={detalleInicialEdicion}
                                documentoId={documento ? documento.DocumentoId : ''}
                                deshabilitado={!detalleInicialEdicion}
                                editarDetalle={editarDetalle}
                                entidades={entidadesDetalle}
                                estado={EstadosDetallesFormulario.EDICION}
                                tipoCantidad="CantidadSolicitada"
                                seriadoConsulta={false}
                                esEntradaInventario={false}
                                esOrdenTraslado={true}
                                esTraslado={false}
                                bloquearCantidadSerial={false}
                            />
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TablaDetalles
                            camposOcultar={CAMPOS_OCULTAR_DETALLES_TABLA}
                            detalles={detalles}
                            editarDetalle={(detalle: IDocumentoDetalleConsultaGeneral) =>
                                setDetalleInicialEdicion(detalle)
                            }
                            editarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEditarDetalle : false
                            }
                            eliminarDetalle={confirmarEliminarDetalle}
                            eliminarDetalleDeshabilitado={
                                documento ? !documento.ListaAcciones.PermiteEliminarDetalle : false
                            }
                            mostrarAcciones={
                                (estado === EstadosModalOrdenSalida.CREACION && Boolean(documento)) ||
                                estado === EstadosModalOrdenSalida.EDICION
                            }
                            recargarTabla={consultarDetalles}
                            titulo={<Texto fontWeight="bold" id="ModalOrdenSalida.TituloTablaDetalles" />}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DocumentoValorTotal detalles={detalles} />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ModalOrdenSalida;
